// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of organisations and contacts (D03, CO-0161). Object scope comes on top: grants per organisation. */
export const crmPermissions = definePermissions('crm', {
  read: 'View organisations and contacts',
  create: 'Add organisations and contacts',
  update: 'Change organisations and contacts, archive and restore them',
  delete: 'Delete contacts that were added by mistake',
  export: 'Export organisations and contacts',
});
